export default {
    methods: {
        numberToWordsVN(number) {
            if (!number && number !== 0) return '';

            const ChuSo = [
                " không", " một", " hai", " ba", " bốn",
                " năm", " sáu", " bảy", " tám", " chín"
            ];
            const Tien = [
                "", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ"
            ];

            function read3digit(num) {
                let tram = Math.floor(num / 100);
                let chuc = Math.floor((num % 100) / 10);
                let donvi = num % 10;
                let result = "";

                if (tram === 0 && chuc === 0 && donvi === 0) return "";

                // hàng trăm
                if (tram !== 0) {
                    result += ChuSo[tram] + " trăm";
                    if (chuc === 0 && donvi !== 0) result += " linh";
                }

                // hàng chục
                if (chuc !== 0 && chuc !== 1) {
                    result += ChuSo[chuc] + " mươi";
                } else if (chuc === 1) {
                    result += " mười";
                }

                // hàng đơn vị
                if (donvi !== 0) {
                    result += ChuSo[donvi]; // chuẩn ngân hàng: không rút gọn
                }

                return result;
            }

            let i = 0;
            let result = "";
            let str = "";
            let num = number;

            if (num === 0) return "Không đồng";

            while (num > 0) {
                let so = num % 1000;
                if (so !== 0) {
                    str = read3digit(so) + Tien[i] + str;
                }
                num = Math.floor(num / 1000);
                i++;
            }

            result = str.trim();
            result = result.charAt(0).toUpperCase() + result.slice(1) + " đồng";
            return result;
        }
    }
}
